/* global __webpack_modules__ */

import d3 from 'd3';
import filtersModule from '../filters/filters';
let filterSwitch = null;

if (__webpack_modules__[require.resolveWeak('angular')]) {
  filterSwitch = angular
    .injector(['ng', filtersModule])
    .get('filterSwitchFilter');
} else {
  filterSwitch = filtersModule;
}

/**
 * Rounds decimals to one order of significance by converting to int first.
 *
 * @param {string} numStr A string representing the right side of a floating
 * point number
 * @param {function} cb A Math function to do rounding
 * @return {number} The rounded decimal
 *
 * @example
 * // up or down
 * '002167' -> .003 || .002
 * '000628' -> .0007 || .0006
 */
function roundDecimal(numStr, direction) {
  return roundInt(parseInt(numStr, 10), numStr, direction) /
    Math.pow(10, numStr.length);
}

/**
 * Rounds integers to one order of significance.
 *
 * @param {number} num Integer to be rounded
 * @param {string} numStr String used to calculate the exponential we need
 * @param {function} cb A Math function to do rounding
 * @return {number} The rounded integer
 */
function roundInt(num, numStr, direction) {
  const roundingDigit = Math.pow(
    10,
    numStr.length - (num > 10 ? 2 : 1)
  );
  const round = Math[direction](num / roundingDigit) * roundingDigit;

  // Add padding at the least significant digit, excluding cases where values
  // have previously been rounded, or percentages (0, 100) that shouldn't
  // be padded
  if (num === round) {
    const modifier = Math[direction](1 / roundingDigit) * roundingDigit;
    const maxMultiplier = numStr.length > 1 ? Math.pow(10, numStr.length) : 1;
    const modified = round + modifier * (direction === 'floor' ? -1 : 1);
    if ((modified < maxMultiplier && direction === 'ceil') ||
        (round !== 0 && direction === 'floor')) {
      return modified;
    }
  }
  return round;
}

export function xTickFormat(d) {
  return this.data[0].tickValues[d];
}

export function yTickFormat(d) {
  return filterSwitch(d, this.data[0].selectedHeader);
}

export function chartY(d) {
  return (d.y !== null) ?
    d.y :
    undefined;
}

export function roundDown(num) {
  if (isNaN(num)) {
    return num;
  }

  const floatPrecision = num.toString().split('.');
  if ((floatPrecision.length === 2 && +floatPrecision[0] > 10) ||
      (floatPrecision.length === 1)) {
    return roundInt(num, floatPrecision[0], 'floor');
  }
  return roundDecimal(floatPrecision[1], 'floor');
}

export function roundUp(num) {
  if (isNaN(num)) {
    return num;
  }

  const floatPrecision = num.toString().split('.');
  if ((floatPrecision.length === 2 && +floatPrecision[0] > 10) ||
      (floatPrecision.length === 1)) {
    return roundInt(num, floatPrecision[0], 'ceil');
  }
  return roundDecimal(floatPrecision[1], 'ceil');
}

export function contentGenerator(key) {
  const y = this.data[0].tickValues[key.value];
  const value = (key.point.formatted === '') ? 0 : key.point.formatted;

  return (`
    <p>${key.series[0].key.split(' -').reverse().join(', ')}: ${value}
    <br />
    ${y}</p>`
  );
}

export default {
  chart: {
    type: 'lineChart',
    height: 375,
    dispatch: {
      renderEnd: function() {
        const pathsToRemove = [];
        // This timeout is necessary to reliably get the DOM elements
        // necessary to remove the null/NA values.  Without this,
        // there are times where the chart SVG will not be ready, resulting
        // in an empty set.
        window.setTimeout(() => {
          // Get the group element and how many points are on the line
          const group = document.querySelector('.nv-scatter .nv-group') || {};
          const pointsPerSeries =
          (group.children) ? group.children.length : 0;

          // For every point, hide a point if it's y-value is null
          // Then, push the index we removed to an array to use later...
          d3.selectAll('.nv-point').each(function(d) {
            const pathIdx = (d[0].series * pointsPerSeries) + d[1];
            if (d[0].y === null) {
              pathsToRemove.push(pathIdx);
              this.style.display = 'none';
            }
          });

          // This timeout is necessary for when the window resizes.
          // The paths we want to remove cause the tooltips to be displayed.
          window.setTimeout(() => {
            pathsToRemove.forEach((x) =>
              d3.select(document.getElementById(`nv-path-${x}`)).remove()
            );
          }, 100);
        }, 0);
      },
    },
    margin: {
      top: 20,
      right: 20,
      bottom: 60,
      left: 50,
    },
    showValues: true,
    showLegend: false,
    valueFormat: function(d) {
      return d3.format(',.4f')(d);
    },
    clipEdge: false,
    tooltip: {
      distance: '20',
      gravity: 's',
      chartContainer: null,
    },
    transitionDuration: 500,
    xAxis: {
      showMinMax: true,
    },
    yAxis: {
      axisLabelDistance: 20,
      tickPadding: 10,
      ticks: 10,
    },
  },
};



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/config/linechart.js
 **/